import { useContext } from "react";

import { AxiosError } from "axios";

import AlertContext from "context/alert/alertContext";
import AuthContext from "context/auth/authContext";
import ParamsContext from "context/params/paramsContext";
import TableContext from "context/table/tableContext";
import { useApi } from "shared/hooks/useApi";
import { TABLE_NAMES } from "shared/types/enums";

import { useTableFunctions } from "./useTableFunctions";

export const useTableRowSignalRActions = () => {
    const { backgroundActionId, backgroundActionTableName } =
        useContext(AlertContext);

    const {
        setReloadItems,
        setDebouncedReloadItems,
        setDebouncedTriggerRootCompany
    } = useContext(ParamsContext);

    const { user } = useContext(AuthContext);

    const { tableName, addBlinkedRow, updateSingleRowData } =
        useContext(TableContext);

    const { isCanceled, getData, handleResponse } = useApi();
    const { getEditRowEndpoint } = useTableFunctions();

    const editRow = async (id: number) => {
        const isDevicesBgActionTable =
            backgroundActionTableName === TABLE_NAMES.Devices;

        const isBackgroundActionNotActive = backgroundActionId === null;

        if (!isDevicesBgActionTable || isBackgroundActionNotActive) {
            const endpoint = getEditRowEndpoint(tableName, id);

            try {
                const { data: itemData } = await getData(endpoint);

                updateSingleRowData(itemData);
                addBlinkedRow(id);

                setReloadItems([
                    TABLE_NAMES.Tasks,
                    TABLE_NAMES.Changes,
                    TABLE_NAMES.ConfigurationOverview,
                    TABLE_NAMES.ConfigurationChanges
                ]);
            } catch (error) {
                if (!isCanceled(error)) {
                    const isNotFound = (error as AxiosError).status === 404;
                    !isNotFound && handleResponse(error);
                }
            }
        }
    };

    const handleDeletion = (id: number) => {
        const isCompaniesTable = tableName === TABLE_NAMES.Companies;

        if (isCompaniesTable) {
            setDebouncedTriggerRootCompany();
        } else {
            const isUsersTable = tableName === TABLE_NAMES.Users;
            const isUserSelf = isUsersTable && user?.id === id;

            !isUserSelf && setDebouncedReloadItems(tableName);
        }
    };

    return { editRow, handleDeletion };
};
